export const transformSlug = (slug: string) => {
  if (!slug) return "";
  const words = slug.includes("_") ? slug.split("_") : [slug];
  return words
    .map((word, index) =>
      index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word
    )
    .join(" ");
};
